import { createFileRoute, redirect } from '@tanstack/react-router'

/** The shadow view opens on the customer's dashboard, as they would. */
export const Route = createFileRoute('/internal/customer-view/$userId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/internal/customer-view/$userId/dashboard',
      params,
    })
  },
})
